import axios from 'axios'
import { URL } from '../../../env'

export default {
  data: () => ({
    syndication_id: localStorage.getItem('syndication_id'),
    total_syndication_part_rtr: 0,
    total_participation_cost: 0,
    portfolio_balance: 0,
    total_payouts: 0,
    netInvestmentNew: 0,
    recent_payouts: {},
  }),
  mounted() {
    this.getSums()
    this.getRecentPayout()
  },
  methods: {
    getSums() {
      axios.get(`${URL}/api/payouts/syndication_sums/` + this.syndication_id).then(res => {
        const sums = res.data.sums
        this.total_syndication_part_rtr = sums.length > 0 ? parseFloat(sums[0].total_syndication_part_rtr) : 0
        this.total_participation_cost = sums.length > 0 ? parseFloat(sums[0].total_participation_cost) : 0
        this.portfolio_balance = sums.length > 0 ? parseFloat(sums[0].portfolio_balance) : 0
        this.total_payouts = res.data.total_payouts ? parseFloat(res.data.total_payouts) : 0
        this.netInvestmentNew = res.data.netInvestmentNew ? parseFloat(res.data.netInvestmentNew) : 0
      })
    },
    getRecentPayout() {
      axios
        .get(`${URL}/api/payouts/get_payouts_paydates/${this.syndication_id}`, { params: { page: 1, length: 25 } })
        .then(res => {
          this.recent_payouts = res.data.data[0] || {}
        })
    },
    netInvestment() {
      return this.total_participation_cost - this.total_payouts + parseFloat(this.currentSyndicate.cash_balance)
    },
    portfolioReturn() {
      let netInvestment = this.netInvestment()
      let cash_balance = this.currentSyndicate && this.currentSyndicate.cash_balance ? this.currentSyndicate.cash_balance : 0
      if (netInvestment != 0) {
        return ((parseFloat(this.portfolio_balance) - parseFloat(netInvestment) + parseFloat(cash_balance)) / netInvestment) * 100
      }
      return 0
    },
  },
}
